export const invitePresetMessages = [
    "Sorry, can't join you",
    "Will join you shortly",
    "I will invite you later"
]